import { fieldNames } from '../../shared/configs/acceptanceForm';
import { selectors, sliceKeys } from '../../model';

const selectCompanyId = selectors[sliceKeys.companies].selectCurrentId;
const { selectHouses, selectExcludedRoomIds, selectRelatedRooms } =
  selectors[sliceKeys.houses];

export const getValuesFromStore = (store) => {
  return {
    [fieldNames.main.relatedAddresses]: selectRelatedRooms(store),
    [fieldNames.main.houses]: selectHouses(store),
    [fieldNames.main.companyId]: selectCompanyId(store),
    [fieldNames.main.addressesForExceptions]: selectExcludedRoomIds(store),
  };
};
